import { Component } from 'preact'
import axios from 'axios'

/* eslint-disable import/no-internal-modules */
import Icon from '@insided/deprecated-preact-components/assets'
import DynamicUserList from '@insided/deprecated-preact-components/list-selector/DynamicUserList'
import { User } from '@insided/deprecated-preact-components/user-selector/User'

import { BulkActionComponentProps } from '@insided/deprecated-control/overview'

import { getIdAndContentTypeFromTopics } from '../../utils'
import ChangeAuthorModal from './ChangeAuthorModal'
import { getInsidedData } from '@insided/destination/utils/insidedDataStorage'

interface Author {
  id?: number
  name?: string
}

interface ChangeAuthorState {
  isModalOpen: boolean
  selectedAuthor: Author
}

class ChangeAuthor extends Component<BulkActionComponentProps, ChangeAuthorState> {
  state = {
    isModalOpen: false,
    selectedAuthor: { id: undefined, name: undefined }
  }

  onSelectedAuthor = async (user: User) => {
    this.setState({ isModalOpen: true, selectedAuthor: { id: Number(user.id), name: user.name } })
  }

  contentType = this.props.type.split('-').join(' ')

  onChangeAuthor = () => {
    const successMessage =
      this.props.numberOfSelectedItems > 1
        ? `You've changed the author of ${this.props.numberOfSelectedItems} ${this.contentType}s to ${this.state.selectedAuthor.name}`
        : `You've changed the author of the ${this.contentType} to ${this.state.selectedAuthor.name}`
    this.props.performBulkAction({
      successMessage,
      onClick: async (selectedTopics: []) =>
        await axios.post(
          `/community/api/bulk/process?moderatorId=${getInsidedData('user').userid}`,
          {
            action: 'changeAuthor',
            topics: getIdAndContentTypeFromTopics(selectedTopics),
            params: {
              authorId: this.state.selectedAuthor.id
            }
          }
        )
    })
  }

  render() {
    const { numberOfSelectedItems } = this.props
    const { isModalOpen, selectedAuthor } = this.state
    return (
      <div>
        <DynamicUserList
          align='right'
          buttonTitle={
            <div>
              <Icon icon='changeAuthor' width={20} height={17} />
              Change author
            </div>
          }
          header={() => <div />}
          onUserClick={this.onSelectedAuthor}
          hasModal
          newStyle
          fetchUrl='/member/getAuthors?filterByRole=1&query='
          feature='change-author'
          placeholder='Search by username'
        />
        <ChangeAuthorModal
          numberOfSelectedItems={numberOfSelectedItems}
          isOpen={isModalOpen}
          onChangeAuthor={this.onChangeAuthor}
          onClose={() => this.setState({ isModalOpen: false })}
          authorName={selectedAuthor.name ?? 'Anonymous author'}
          type={this.contentType}
        />
      </div>
    )
  }
}

export default ChangeAuthor
